import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Testimonialsabout = () => {
  const testimonials = [
    {
      image: "/img/testimonial/testi_1_1.jpg",
      title: "Excellent Airport Transfer",
      text: "Booked a Pune Airport cab with Rising Cab Service and the experience was outstanding. The driver arrived on time, the car was clean, and the journey was comfortable.",
      name: "Mr. Rahul Sharma",
    },
    {
      image: "/img/testimonial/testi_1_2.jpg",
      title: "Best Pune to Mumbai Cab",
      text: "Rising Cab Service provided a smooth and affordable Pune to Mumbai journey. The booking process was simple and the driver was very professional.",
      name: "Mrs. Priya Patil",
    },
    {
      image: "/img/testimonial/testi_1_3.jpg",
      title: "Safe Family Trip",
      text: "We booked an outstation cab for our family vacation and had a wonderful experience. The vehicle was well maintained and the service was excellent.",
      name: "Mr. Amit Deshmukh",
    },
    {
      image: "/img/testimonial/testi_1_1.jpg",
      title: "Comfortable Shirdi Darshan",
      text: "Our Shirdi Darshan package with Rising Cab Service was perfectly organized. The driver was courteous and ensured a safe and comfortable pilgrimage.",
      name: "Miss Sneha Kulkarni",
    },
    {
      image: "/img/testimonial/testi_1_2.jpg",
      title: "Reliable Cab Service",
      text: "I frequently use Rising Cab Service for local travel in Pune. Their cabs are always clean, the fares are reasonable, and the drivers are punctual.",
      name: "Mr. Sandeep Joshi",
    },
    {
      image: "/img/testimonial/testi_1_3.jpg",
      title: "Great Tour Package Experience",
      text: "We booked the Lonavala Khandala tour package with Rising Cab Service and enjoyed a hassle-free trip. Highly recommended for family outings.",
      name: "Mrs. Pooja Chavan",
    },
  ];

  return (
    <section
      className="testi-card-area-1 space bg-smoke overflow-hidden"
      id="testi-sec"
    >
      <div className="shape-mockup">
        <img
          src="/img/shape/testi-irhgt-shpae-bg.png"
          alt="shape"
        />
      </div>

      <div className="container">
        {/* Section Title */}
        <div className="row justify-content-center">
          <div className="col-xxl-7 col-xl-7">
            <div className="title-area text-center">
              <span className="sub-title">Customer Reviews</span>
              <h2 className="sec-title">
                What Our Customers Say About Rising Cab Service
              </h2>
              <p>
                Rising Cab Service is committed to providing safe, reliable,
                affordable, and comfortable taxi services for local,
                airport, outstation, and tour package travel.
              </p>
            </div>
          </div>
        </div>

        {/* Testimonials */}
        <div className="row gy-4 justify-content-center">
          <div className="testi-card-slide position-relative">
            <Swiper
              modules={[Autoplay, Navigation, Pagination]}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              navigation={{
                nextEl: ".testimonial-next",
                prevEl: ".testimonial-prev",
              }}
              pagination={{
                clickable: true,
              }}
              spaceBetween={30}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                992: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                },
              }}
            >
              {testimonials.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="testi-block">

                    {/* Customer Image */}
                  {/*  <div className="box-img text-center mb-3">
                       <img
                        src={item.image}
                        alt={item.name}
                        className="rounded-circle"
                      />
                    </div> */}

                    <div className="content">

                      {/* Rating */}
                      <div className="box-review text-center mb-3">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className="fas fa-star"
                            style={{
                              color: "#F26A21",
                              marginRight: "3px",
                            }}
                          ></i>
                        ))}

                        <div className="rating mt-2">
                          <span>5.0 / 5.0 Reviews</span>
                        </div>
                      </div>

                      {/* Title */}
                      <h3 className="box-title text-center">
                        {item.title}
                      </h3>

                      {/* Text */}
                      <p className="box-text text-center">
                        "{item.text}"
                      </p>

                      {/* Footer */}
                      <div className="content-bottom d-flex justify-content-between align-items-center">

                        <div className="left">
                          <h4 className="name-title">
                            {item.name}
                          </h4>
                          <p className="box-desig">
                            Verified Customer
                          </p>
                        </div>

                        <div className="right">
                          <i
                            className="fas fa-quote-right"
                            style={{
                              fontSize: "40px",
                              color: "#F26A21",
                              opacity: "0.4",
                            }}
                          ></i>
                        </div>

                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Navigation */}
            <button className="slider-arrow slider-prev testimonial-prev">
              <i className="fas fa-arrow-left"></i>
            </button>

            <button className="slider-arrow slider-next testimonial-next">
              <i className="fas fa-arrow-right"></i>
            </button>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonialsabout;